import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { getPartnerContactsCrud } from '../lib/getPartnerContactsCrud'
import { CREATE_CONTACT } from '../model/constants'
import { IPartnerContact } from '../model/types'
import { selectContactsFilters } from '../selectors/selectContactsFilters'

interface ICreateContactParams {
  roles: string
  contactId: string
  email: string
  firstName: string
  lastName: string
  fullName: string
}

export const createContact = createAsyncThunk<IPartnerContact, ICreateContactParams>(
  CREATE_CONTACT,
  async (selectedPartner, { getState }) => {
    const { programType, partnerId } = selectContactsFilters(getState())
    const crud = getPartnerContactsCrud({ partnerId, programType })

    if (!programType || !partnerId) {
      throw new Error('Program type or partner ID is not set')
    }

    const [contact] = await crud.create({ formId: '700', code: 'PartnerContacts' }, [
      {
        Roles: selectedPartner.roles,
        ContactId: selectedPartner.contactId,
        Email: selectedPartner.email,
        FirstName: selectedPartner.firstName,
        LastName: selectedPartner.lastName,
        FullName: selectedPartner.fullName,
        PartnerId: partnerId,
        ProgramType: programType,
      },
    ])

    return {
      FirstName: selectedPartner.firstName,
      LastName: selectedPartner.lastName,
      FullName: selectedPartner.fullName,
      Email: selectedPartner.email,
      ...contact,
    }
  }
)
